import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const updateQuestionsOrderOperation = async (
  pollId: number,
  questionsOrder: { questionId: number; orderItem: number }[],
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);
    await appApi.updatePollQuestionsOrder(pollId, questionsOrder);
    await globalSettingsStores.fetchSetting();
    toast.success('סדר השאלות עודכן בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
